import { ANOS_ECONOMIA, TEXTOS, type Analise } from '@sc/shared/triagem';

const brl = (n: number) => n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
/** "R$ 6,5 mil", "R$ 182 mil", "R$ 1,2 milhão": números grandes mais fáceis de ler. */
function brlCurto(n: number) {
  if (n >= 1_000_000) return `R$ ${(n / 1_000_000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} ${n >= 2_000_000 ? 'milhões' : 'milhão'}`;
  if (n >= 10_000) return `R$ ${Math.round(n / 1000).toLocaleString('pt-BR')} mil`;
  if (n >= 1000) return `R$ ${(n / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mil`;
  return brl(n);
}
const kwp = (n: number) => n.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 2 });
const anos = (n: number) => `${n.toLocaleString('pt-BR', { maximumFractionDigits: 1 })} ${n === 1 ? 'ano' : 'anos'}`;

/** Pré-análise calculada no servidor. A pessoa vê sistema, área e economia; investimento só se a Sun Coast configurar. */
export function AnaliseCard({ a }: { a: Analise }) {
  return (
    <section className="chat-analise" aria-label="Pré-análise do seu projeto">
      <h3>Pré-análise do seu projeto</h3>
      <div className="an-destaque">
        <span className="an-label">Economia estimada</span>
        <strong>
          {brl(a.economiaMesMin)} a {brl(a.economiaMesMax)}
          <small> por mês</small>
        </strong>
        <span className="an-sub">
          {brlCurto(a.economiaAnoMin)} a {brlCurto(a.economiaAnoMax)} por ano
        </span>
      </div>
      <dl className="an-grid">
        <div>
          <dt>Sistema indicado</dt>
          <dd>
            {kwp(a.kwp)} kWp · {a.paineis} painéis
          </dd>
        </div>
        <div>
          <dt>Geração estimada</dt>
          <dd>~{a.geracaoKwh.toLocaleString('pt-BR')} kWh/mês</dd>
        </div>
        <div>
          <dt>Área de telhado</dt>
          <dd>~{a.areaM2} m²</dd>
        </div>
        <div>
          <dt>Em {ANOS_ECONOMIA} anos</dt>
          <dd>até {brlCurto(a.economiaLongoMax)}</dd>
        </div>
        {a.investimentoMin !== null && a.investimentoMax !== null && (
          <div>
            <dt>Investimento estimado</dt>
            <dd>
              {brlCurto(a.investimentoMin)} a {brlCurto(a.investimentoMax)}
            </dd>
          </div>
        )}
        {a.retornoAnosMin !== null && a.retornoAnosMax !== null && (
          <div>
            <dt>Retorno do investimento</dt>
            <dd>{a.retornoAnosMin === a.retornoAnosMax ? anos(a.retornoAnosMin) : `${anos(a.retornoAnosMin).replace(/ anos?$/, '')} a ${anos(a.retornoAnosMax)}`}</dd>
          </div>
        )}
      </dl>
      <p className="an-nota">
        {TEXTOS.analiseAviso} Em {ANOS_ECONOMIA} anos, sem contar reajustes da tarifa.
        {a.sobMedida && ` ${TEXTOS.analiseSobMedida}`}
      </p>
    </section>
  );
}
